import React from 'react'
import Search from '../search'

function SearchNavigationBarXS() {
  return (
    <div className={[_s.d, _s.z4, _s.minH53PX, _s.w100PC].join(' ')}>
      <div className={[_s.d, _s.minH53PX, _s.bgNavigation, _s.aiCenter, _s.z3, _s.top0, _s.right0, _s.left0, _s.posFixed].join(' ')} >
        <div className={[_s.d, _s.saveAreaInsetPT, _s.saveAreaInsetPL, _s.saveAreaInsetPR, _s.w100PC].join(' ')}>
          <div className={[_s.d, _s.px10, _s.w100PC].join(' ')}>
            <Search isXS className={_s.w100PC} isInNav />
          </div>
        </div>
      </div>
    </div>
  )
}

export default SearchNavigationBarXS